import { useContext } from 'react';

import { tableCacheKeys } from 'constants/tableCacheKeys';
import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';
import { convertChartDatapointToCostReportData } from 'features/cost-report/utils/networkCosts';

import { useReportDownload } from './_hooks/useReportDownload';
import { NetworkDailyDetailsTable } from './NetworkDailyDetailsTable';
import { NetworkCostOverTimeContext } from '../../providers/NetworkCostOverTimeProvider';

export const DailyDetailsSection = () => {
  const { current } = useContext(NetworkCostOverTimeContext);
  const { timezone } = useCostReportContext();
  const downloadData = convertChartDatapointToCostReportData(current.chartData);
  const { download } = useReportDownload(
    'daily-network-spend-details',
    downloadData
  );

  return (
    <NetworkDailyDetailsTable
      chartData={current.chartData}
      isLoading={current.isLoading}
      timezone={timezone}
      cacheKey={tableCacheKeys.COST_MONITORING.CLUSTER.NETWORK_DETAILS}
      testId="daily-network-details-table"
      onDownload={download}
    />
  );
};
